import { render } from "./QuestionAndAnswerView.vue?vue&type=template&id=1b28acb1&scoped=true"
import script from "./QuestionAndAnswerView.vue?vue&type=script&lang=js"
export * from "./QuestionAndAnswerView.vue?vue&type=script&lang=js"

import "./QuestionAndAnswerView.vue?vue&type=style&index=0&id=1b28acb1&scoped=true&lang=css"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b28acb1"]])

export default __exports__